import React from 'react'
import { Link } from 'react-router-dom'
import mac from "./img/gravity.png"
import web from "./img/gravity.png"
import Image from "../../../../Components/Image"

function Gravity() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">Gravity</div>
                <div className="work_type">SAAS</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                        Gravity is a Fintech solution created at 3LINE LTD.
                        The solution enables bank agent consummate transaction on behalf of the bank using a POS, Mobile device, Web or USSD. Gravity is able to power the following transaction:
                        <ul>
                            <li>Account Opening with instant card issuance</li>
                            <li>Cash withdrawal</li>
                            <li>Cash Deposit</li>
                            <li>PIN Change on POS</li>
                            <li>Funds Transfer</li>
                            <li>Bill Payment</li>
                            <li>Airtime</li>
                            <li>Thrift Collection</li>
                            <li>Disbursement</li>
                            <li>Loan request and collection</li>
                            <li>Balance Enquiry</li>
                            <li>Mini Statement</li>
                        </ul>
                        An extension of Gravity Agent Banking is the branchless banking platform. It allows the agent perform additional transactions which are not agent banking transactions.

                        Transactions on Branchless Banking include:
                        <ul>
                            <li>All agent banking transactions</li>
                            <li>Customer Service</li>
                            <li>Dispute Resolution</li>
                            <li>Cheque book request</li>
                        </ul>
                        Gravity's flexible implementation however, makes it possible to implement the requisite levels of control and risk limits of the financial institution.
                    </p>

                    {/* <a href='https://apps.apple.com/gb/app/oudi/id1571999846' className="work_btn" target='_blank'>Get on the app store</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                    <a href='https://medusa.3lineng.com/#/' className="work_btn" target='_blank'>Visit Website</a>
                </div>
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">

                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> ReactJs, SASS, Redux, NextJs.</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default Gravity